<script context="module">
    function* gridify(D) {
        let level = Math.ceil(Math.log2(D.length) / Math.log2(4));
        let curveLength = 2 ** level;
        const start = performance.now();
        const P = new Map();
        let N = D.length;
        const cl = curveLength ** 2;

        function decode() {
            let Y = [];
            for (const [p, i] of P) {
                const y = hilbert_decode(p, curveLength);
                y.i = i;
                y.p = p;
                Y.push(y);
            }
            Y = Y.sort((a, b) => a.i - b.i);
            return Y;
        }
        let collisions = [];

        const scaledD = D.map(
            (d) => d.map((d) => Math.floor(d + 0.5)) //d.map(v => (v * curveLength) / W).map(Math.floor)
        );

        for (let i = 0; i < N; ++i) {
            collisions = [];
            const d = scaledD[i];
            let [x, y] = d;
            let p = hilbert_encode(x, y, curveLength);
            let res = {};
            if (P.has(p)) {
                let p_left = p;
                let p_right = p;
                let done = false;
                while (!done) {
                    --p_left;
                    ++p_right;
                    if (p_left >= 0) collisions.push([p_left + 1, p_left]);
                    if (p_right <= cl + 1)
                        collisions.push([p_right - 1, p_right]);
                    let left = P.has(p_left);
                    let right = P.has(p_right);

                    if (left && right) {
                    } // left and right occupied;
                    else if (p_left >= 0 && !left && right) {
                        // left empty and valid, right occupied
                        P.set(p_left, i);
                        done = true;
                    } else if (p_left < 0 && !left && right) {
                        // left invalid, right occupied
                    } else if (left && !right && p_right <= cl) {
                        // left occupied, right empty and valid
                        P.set(p_right, i);
                        done = true;
                    } else if (left && !right && p_right > cl) {
                        // left occupied, right invalid
                    } else if (!left && !right) {
                        // left and right empty
                        if (p_left >= 0 && p_right <= cl) {
                            // both valid
                            const distance_left = distance(
                                d,
                                hilbert_decode(p_left, curveLength)
                            );
                            const distance_right = distance(
                                d,
                                hilbert_decode(p_right, curveLength)
                            );
                            // check for better spot
                            P.set(
                                distance_left < distance_right
                                    ? p_left
                                    : p_right,
                                i
                            );
                            res.desicion = distance_left < distance_right
                                    ? "predecessor"
                                    : "successor",
                            done = true;
                        } else if (p_left < 0 && p_right <= cl) {
                            // right valid
                            P.set(p_right, i);
                            done = true;
                        } else if (p_left >= 0 && p_right > cl) {
                            // left valid
                            P.set(p_left, i);
                            done = true;
                        } else {
                            // should not happen
                            throw "should not happen 1";
                        }
                    } else {
                        throw "should not happen 2";
                    }
                }
            } else {
                P.set(p, i);
            }
            res = Object.assign(res, {
                data: decode(),
                stat: "set",
                point: p,
                runtime: performance.now() - start,
                collisions: collisions.slice(),
            });
            yield res;
        }
        return {
            data: decode(),
            stat: "fin",
            runtime: performance.now() - start,
            collisions: collisions.slice(),
        };
    }

    function hilbert_encode(px, py, size) {
        let n = 0;
        for (let s = size >> 1; s > 0; s >>= 1) {
            const rx = (px & s) > 0;
            const ry = (py & s) > 0;
            n += s * s * ((3 * rx) ^ ry);
            [px, py] = rotate(s, px, py, rx, ry);
        }
        return n;
    }

    function hilbert_decode(n, size) {
        let t = n;
        let [px, py] = [0, 0];
        for (let s = 1; s < size; s *= 2) {
            const rx = 1 & (t / 2);
            const ry = 1 & (t ^ rx);
            [px, py] = rotate(s, px, py, rx, ry);
            px += s * rx;
            py += s * ry;
            t = t >> 2;
        }
        return [px, py];
    }

    function rotate(size, px, py, rx, ry) {
        if (ry == 0) {
            if (rx == 1) {
                px = size - 1 - px;
                py = size - 1 - py;
            }
            return [py, px];
        }
        return [px, py];
    }

    function distance([x1, y1], [x2, y2]) {
        return Math.hypot(x1 - x2, y2 - y1);
    }

    let image_names = ["flowers", "cow", "dog", "child", "man", "ship", "cow", "train", "woman", "last"];
</script>

<script>
    import { select } from "d3";

    let scrollables = {};
    function makeScrollable(name, scrollFn, initFn, stopFn) {
        /* console.log("makeScrollable"); */
        var slides = select(".slides");
        var s = slides.selectAll(".scrollable-" + name).data([{}]);

        // If the div doesn't exist create it;
        s = s
            .enter()
            .append("div")
            .attr("class", "scrollable scrollable-" + name)
            .merge(s);

        // Default initFn
        initFn = initFn || function () {};

        // Default scrollFn
        scrollFn =
            scrollFn ||
            function (step) {
                s.select("text")
                    .transition()
                    .duration(1000)
                    .text("Step=" + step);
            };
        stopFn = stopFn || function () {};

        // Bind the this element
        initFn = initFn.bind(s.node());
        scrollFn = scrollFn.bind(s.node());
        stopFn = stopFn.bind(s.node());

        // Run the init code
        initFn();

        // Add the scrollable to the list
        scrollables[name] = {
            scroll: scrollFn,
            stop: stopFn,
        };
    }

    import * as d3 from "d3";

    import { morph_c, morph_d } from "../custom_actions.js";

    import { reveal } from "../stores/store.js";
    import { onMount } from "svelte";
    import { fade, fly, draw } from "svelte/transition";
    import interact from "interactjs";

    $reveal.addEventListener("slidechanged", function (event) {
        var scrollable;

        if (d3.select(event.currentSlide).classed("scroll")) {
            if (
                d3.select(event.currentSlide).attr("step") &&
                d3.select(event.currentSlide).attr("scrollable")
            ) {
                scrollable = d3.select(event.currentSlide).attr("scrollable");

                d3.select(".scrollable-" + scrollable)
                    .style("visibility", "visible")
                    .style("opacity", 1);
                d3.select(".reveal").classed("scrolling", true);
                if (scrollable in scrollables) scrollables[scrollable].scroll(
                    d3.select(event.currentSlide).attr("step")
                );
            }
        } else {
            // Not scrolling

            // Stop all scrollables
            for (var s in scrollables) {
                scrollables[s].stop();
            }
            d3.selectAll(".scrollable")
                .style("visibility", "hidden")
                .style("opacity", 0);
            d3.select(".reveal").classed("scrolling", false);
        }
    });

    const W = 500;
    const H = 700;
    const M = 40;
    const range = [M, W - M];

    let step;
    function doStep(event) {
        //console.log("hagrid do step", +event);
        step = +event;
    }

    onMount(async () => {
        makeScrollable("hagrid", doStep);
    });

    let data = [[0.15,0.07],[0.9460000610351562,0.06],[1,0.4680000305175781],[2.0679998779296875,2.3179998779296875],[2.996000061035156,1.251999969482422],[2.2160000610351562,1.7120001220703125],[1.62,2.926000061035156],[0.16400001525878907,0.4619999694824219],[0.23,1.99],[1.538000030517578,2.1060000610351564]]

    let fly_transition = { duration: 2000 };
    let level = 2;
    $: hilbert_size = 2 ** level;
    $: hilbert_length = 4 ** level;
    $: hilbert_color_scale = d3
        .scaleSequential(d3.interpolateWarm)
        .domain([0, hilbert_length]);
    $: hilbert_curve = d3
        .range(0, hilbert_length)
        .map((k) => hilbert_decode(k, hilbert_size))
        .map((d) => d.map((v) => ((v + 0.5) / hilbert_size) * W));
    
    $: hilbert_circles = (step < 3 || step > 4 + gridify_data.length)
                        ? hilbert_curve 
                        : hilbert_curve.map((_, i) => [3 * W / 4, one_d_x(i)]);

    $: hilbert_path = d3.pairs(hilbert_circles)

    $: offset = (0.5 / hilbert_size) * W;
    //$: x = (v) => Math.round(offset + (v / hilbert_size) * W); //d3.scaleLinear([0, 5], [margin, W - margin]);
    $: x = d3.scaleLinear().domain([-.5, hilbert_size - .5]).range([0, W])
    $: y = x; //d3.scaleLinear([0, 5], [margin, W - margin]);
    $: s = (x(1) - x(0)) * 0.5 * 1.5;
    
    $: one_d_x = d3.scaleLinear().domain([0, hilbert_length]).range(step >= 3 ? [M * 1.5, H - M * 1.5] : range)
    $: s_one_d = one_d_x(1) - one_d_x(0);

    $: gridify_data = [...gridify(data)];
    $: console.log(gridify_data)
    function make_draggable(node, { index }) {
        //const X = d3.scaleLinear().domain([0, W]).range([x(0), x(hilbert_size)])
        //const svg = node.parentElement.parentElement;
        interact(node).draggable({
            modifiers: [
                interact.modifiers.restrictRect({restriction: 'parent'})
            ],
            listeners: {
                move (event) {
                    //console.log(event)
                    let pos = data[index].map(x)
                    pos[0] += (event.dx)
                    pos[1] += (event.dy)
                    data[index] = pos.map(x.invert);
                    /* data[index][0] = data[index][0] + (event.dx) / ((W+2) * hilbert_size);
                    data[index][1] = data[index][1] + (event.dy) / ((W+2) * hilbert_size); */
                    /* data[index][0] += X(event.dx)
                    data[index][1] += X(event.dy) */
                },
                end (event) {
                    data = data;
                }
            }
        })
    }
</script>

<section style="display: flex !important; flex-wrap: wrap; justify-content: center;">
    {#if step == 1}
        <h2>Hagrid</h2>
    {/if}
    <section class="scroll" scrollable="hagrid" step=1>
        Scatterplot of some images with overlap
        <aside class="notes">
            Here, i want to illustrate hagrid, with a simple example of another 
            scatterplot with ten images, where some of them overlap.
        </aside>
    </section>
    <section class="scroll" scrollable="hagrid" step=2>
        <h5>first step</h5>
        <p>defining the grid</p>
        <aside class="notes">
            In the first step, a level of the hilbert curve gets selected which provides enough 
            grid cells for the scatterplot, and the points get mapped to fit into that grid.
        </aside>
    </section>
    <section class="scroll" scrollable="hagrid" step=3  style="display: flex; flex-wrap: wrap; justify-content: center">
        <h5>second step</h5>
        <svg width={W + 2} height={W +2 } style="margin: 15px -10%;">
            <g transform="translate(1, 1)"
                fill="white"
                text-anchor="middle"
                dominant-baseline="central"
                font-size="20"
                font-weight="900 !important">
                    <g transition:fade shape-rendering="crispEdges">
                        {#each d3.range(-1, hilbert_size) as i}
                            <path d="M {x(i + .5)} 0 v {W}" fill="none" stroke="grey" stroke-width=.5 />
                            <path d="M 0 {x(i + .5)} h {W}" fill="none" stroke="grey" stroke-width=.5 />
                        {/each}
                    </g>
                    {#each d3.pairs(hilbert_curve) as [p1, p2], i}
                        <path transition:fade use:morph_d={{points: [p1, p2]}} fill="none" stroke={hilbert_color_scale(i + .5)} stroke-width=5 /> 
                    {/each}
                    {#each hilbert_curve as [px, py], i}
                        <circle transition:fade use:morph_c={{point: [px, py]}} r=8 fill={hilbert_color_scale(i)} />
                    {/each}
                    {#each data as d, i}
                        <g use:make_draggable={{index: i}}
                            transition:fade 
                            style="transform: translate({x(d[0])}px, {y(d[1])}px)">
                            <image
                                id="img_{i}"
                                xlink:href="./images/paintings/{i + 1}.png"
                                x={-s / 2}
                                y={-s / 2}
                                width={s}
                                height={s} />
                        </g>
                    {/each}
            </g>
        </svg>
        <p>move to 1d</p>
        <aside class="notes">
            In the next step, the images get placed onto the curve.
            if a spot is already occupied by another image, the method looks at the predecessors and successors of the spot to find an empty one.
            The neighborhood preservation property of the SFC ensures, that a spot near the original spot on the curve is also close in 2d.
        </aside>
    </section>
    {#each gridify_data as {data, collisions, point, desicion}, i}
        <section  class="scroll" scrollable="hagrid" step={4 + i} data-transition="fade">
            <h5>second step</h5>
            <div id="image_container">
                {#each gridify_data as _, j}
                    <img 
                        src="./images/paintings/{j + 1}.png" 
                        alt="what to insert" 
                        class:inactive={i < j}
                        />
                {/each}
            </div>
            <p>
                {#if collisions.length == 0}
                    no collision
                {:else}
                    checks: {collisions.length}
                {/if}    
            </p>
            <aside class="notes">
                {#if desicion}
                    Here, the algorithm found two empty and valid spots. The image gets placed, where the image is closer to its original position.
                    {#if collisions.map(([i1, i2]) => i1 >= i2).reduce((a, b) => a && b)} The spot For the <em>({image_names[i]})</em> has no predecessor, so the algorithm can only look forwards.{/if}
                    {#if collisions.map(([i1, i2]) => i1 <= i2).reduce((a, b) => a && b)} The spot For the <em>({image_names[i]})</em> has no successor, so the algorithm can only look backwards.{/if} 
                    <br />
                {:else}
                    {#if collisions.length > 0}
                        The image should go to the {point + 1}. spot.
                        <!-- {#if collisions.map(([i1, i2]) => i1 >= i2).reduce((a, b) => a + b) < collisions.map(([i1, i2]) => i1 <= i2).reduce((a, b) => a && b)} 
                        There are no empty valid spaces backwards, so the algorithm has to continue forwards.
                        {/if}
                        {#if collisions.map(([i1, i2]) => i1 >= i2).reduce((a, b) => a + b) > collisions.map(([i1, i2]) => i1 <= i2).reduce((a, b) => a && b)} 
                        There are no empty valid spaces forwards, so the algorithm has to continue backwards.
                        {/if} -->
                        After some collisions
                    {/if}
                    the <em>({image_names[i]})</em> {i + 1}. image gets placed on the {data[i].p + 1}. spot 
                    {#if collisions.length == 0} without a collision{/if}
                {/if}                
            </aside>
        </section>
    {/each}
    <section class="scroll" scrollable="hagrid" step={4 + gridify_data.length}>
        all collisions removed
        <aside class="notes">
            all images are now placed onto the curve, each on o own spot.
        </aside>
    </section>
    <section class="scroll" scrollable="hagrid" step={4 + gridify_data.length + 1} style="display: flex; flex-wrap: wrap; justify-content: center">
        <h5>Third step</h5>
        <svg width={W + 2} height={W + 2} style="margin: 15px -10%;">
            <g transform="translate(1, 1)"
                fill="white"
                text-anchor="middle"
                dominant-baseline="central"
                font-size="20"
                font-weight="900 !important">
                    <g transition:fade shape-rendering="crispEdges">
                        {#each d3.range(-1, hilbert_size) as i}
                            <path d="M {x(i + .5)} 0 v {W}" fill="none" stroke="grey" stroke-width=.5 />
                            <path d="M 0 {x(i + .5)} h {W}" fill="none" stroke="grey" stroke-width=.5 />
                        {/each}
                    </g>
                    {#each d3.pairs(hilbert_curve) as [p1, p2], i}
                        <path transition:fade use:morph_d={{points: [p1, p2]}} fill="none" stroke={hilbert_color_scale(i + .5)} stroke-width=5 /> 
                    {/each}
                    {#each hilbert_curve as [px, py], i}
                        <circle transition:fade use:morph_c={{point: [px, py]}} r=8 fill={hilbert_color_scale(i)} />
                    {/each}
                    {#each data as d, i}
                        <g use:make_draggable={{index: i}}
                            transition:fade 
                            style="transform: translate({x(d[0])}px, {y(d[1])}px)">
                            <image
                                id="img_{i}"
                                xlink:href="./images/paintings/{i + 1}.png"
                                x={-s / 2}
                                y={-s / 2}
                                width={s}
                                height={s} />
                        </g>
                    {/each}
            </g>
        </svg>
        back to 2d
        <aside class="notes">
            In the last step, the images get moved back to 2d. 
            Which results, in an overlap free scatterplot, where 
            the grid positions of the images are not too far from the original positions.
        </aside>
    </section>
</section>

<div class="scrollable scrollable-hagrid">
    <div>
        {#if step}
            <svg width={W + 2} height={H}>
                <defs>
                    <marker
                        id="arrow_white"
                        markerWidth="10"
                        markerHeight="10"
                        refX="9"
                        refY="3"
                        orient="auto"
                        markerUnits="strokeWidth"
                    >
                        <path d="M0,0 L0,6 L9,3 z" fill="white" />
                    </marker>
                </defs>
                <g class="animated" style="transform: translate(1px, {(step >= 3 && step < 4 + gridify_data.length + 1) ? 1 : ((H - W) / 2)}px)"
                    fill="white"
                    text-anchor="middle"
                    dominant-baseline="central"
                    font-size="20"
                    font-weight="900 !important">

                    {#if step >= 2 && step < 3}
                        <g transition:fade shape-rendering="crispEdges">
                            {#each d3.range(-1, hilbert_size) as i}
                                <path d="M {x(i + .5)} 0 v {W}" fill="none" stroke="grey" stroke-width=.5 />
                                <path d="M 0 {x(i + .5)} h {W}" fill="none" stroke="grey" stroke-width=.5 />
                            {/each}
                        </g>
                    {/if}
                    {#if step >= 2}
                        {#each hilbert_path as [p1, p2], i}
                            <path 
                                use:morph_d={{points: [p1, p2]}}
                                fill="none" 
                                stroke={hilbert_color_scale(i + .5)} 
                                stroke-width=5 /> 
                        {/each}
                        {#each hilbert_circles as [x, y], i}
                            <circle 
                                use:morph_c={{point: [x, y]}}  
                                r=8 
                                fill={hilbert_color_scale(i)} />
                        {/each}
                    {/if}
                    {#if step >= 1 && step < 3}
                        {#each data as d, i}
                            <g transition:fade style="transform: translate({x(d[0])}px, {y(d[1])}px)">
                                <image
                                    id="img_{i}"
                                    xlink:href="./images/paintings/{i + 1}.png"
                                    x={-s / 2}
                                    y={-s / 2}
                                    width={s}
                                    height={s} />
                            </g>
                        {/each}
                    {/if}
                    {#if step >= 4}
                        {#each gridify_data[Math.min(step - 4, gridify_data.length - 1)].data as d, i}
                            <g out:fade={{duration: 0}} 
                                style="transform: 
                                    translate(
                                        {((step - 4 == d.i && step - 4 < gridify_data.length) ? ((W / 2)) : (3 * W / 4 + 40))}px, 
                                        {one_d_x((step - 4 == d.i && step - 4 < gridify_data.length) ? gridify_data[Math.min(step - 4, gridify_data.length - 1)].point : d.p)}px
                                    ) 
                                    scale({(step - 4 == d.i) ? 1 : 0.5})">
                                {#if step - 4 < gridify_data.length && step - 4 == i}
                                    <g out:fade={{duration: 0}}
                                        fill="none"
                                        stroke="white"
                                        stroke-width=2>
                                        <path in:draw={{duration: 1000}} out:fade={{duration: 0}}
                                            d="M 0 0 H {W / 4 - 8}" />
                                        {#each gridify_data[Math.min(step - 4, gridify_data.length - 1)].collisions as c, i}
                                            <path in:draw={{duration: 1000, delay: 1000 + 1000 * Math.abs(gridify_data[Math.min(step - 4, gridify_data.length - 1)].point - c[0])}}
                                                d="M {W / 4 - 8} {((c[0] - gridify_data[Math.min(step - 4, gridify_data.length - 1)].point)) * s_one_d} q {-s_one_d} {s_one_d / 2 * Math.sign(c[1] - c[0])} 0 {s_one_d * Math.sign(c[1] - c[0])}" /> 
                                        {/each}
                                    </g>
                                    {#if gridify_data[Math.min(step - 4, gridify_data.length - 1)].collisions.length > 0}
                                        <circle 
                                            in:fade={{duration: 100, delay: 1000 + 1000 * (Math.abs(gridify_data[Math.min(step - 4, gridify_data.length - 1)].point - d.p))}}
                                            out:fade={{duration: 0}}
                                            cx={W / 4} cy={(s_one_d) * (d.p - gridify_data[Math.min(step - 4, gridify_data.length - 1)].point)}
                                            fill="none"
                                            r=12 stroke="white"
                                            stroke-width=2
                                            />
                                        <text 
                                            in:fade={{duration: 100, delay: 1000 + 1000 * (Math.abs(gridify_data[Math.min(step - 4, gridify_data.length - 1)].point - d.p))}}
                                            out:fade={{duration: 0}}
                                            x={W / 4 + 18}
                                            y={(s_one_d) * (d.p - gridify_data[Math.min(step - 4, gridify_data.length - 1)].point)}
                                            text-anchor="start" 
                                            font-weight=900>
                                            free spot
                                        </text>
                                    {/if}
                                {/if}

                            </g>

                            <g in:fade={{duration: 1000}}
                                class="animated" 
                                style="transform: 
                                            translate(
                                                {(step < 4 + gridify_data.length + 1)
                                                    ? (((step - 4 == d.i && step - 4 < gridify_data.length) ? ((W / 2)) : (3 * W / 4 + 40)))
                                                    : x(d[0])
                                                }px, 
                                                {(step < 4 + gridify_data.length + 1)
                                                    ? one_d_x((step - 4 == d.i && step - 4 < gridify_data.length) ? gridify_data[Math.min(step - 4, gridify_data.length - 1)].point : d.p)
                                                    : x(d[1])
                                                }px
                                            ) 
                                            scale({(step - 4 == d.i) ? 1 : (step >= 4 + gridify_data.length + 1 ? 1.2 : 0.5)})">
                                
                                <image
                                    id="img_{i}"
                                    xlink:href="./images/paintings/{i + 1}.png"
                                    x={-s/2}
                                    y={-s/2}
                                    width={s}
                                    height={s} />
                            </g>
                        {/each}
                    {/if}
                </g>
            </svg>
        {/if}
    </div>
</div>

<style>
    .animated {
        transition: 1s ease-in-out transform;
    }

    image {
        filter: drop-shadow(4px 8px 8px #111a);
    }

    #image_container {
        display: flex;
        flex-wrap: wrap;
        justify-content: center;
        gap: 0.4em;
    }

    #image_container > img {
        margin: 0 !important;
        max-width: 80px;
        max-height: 80px;
    }

    #image_container > img.inactive {
        filter: grayscale(1) opacity(0.4);
    }
</style>